import { Cancel } from '@mui/icons-material';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import {
    Box,
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Table,
    TableCell,
    TableRow,
    Tooltip,
    Typography
} from '@mui/material';
import { green, grey, red } from '@mui/material/colors';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Component } from 'react';

class IconeAdvogadoPedidoDestaque extends Component {
    titlePadrao = this.props.motivoDestaque ? 'Ver justificativa do pedido de destaque' : 'Pedido de destaque';
    corPadrao = 'black';
    opacidadePadrao = '1';
    situacaoPedidoDestaque = this.props.deferimento?.tipoSituacao?.descricao
        ? ' - ' + this.props.deferimento?.tipoSituacao?.descricao
        : '';

    title = null;
    color = null;
    removerTooltip = false;
    idPadrao = 'idIconeAdvogadoPedidoDestaque';
    openModalJustificativa = false;

    static get sxPadrao() {
        return {
            color: this.corPadrao,
            fill: this.corPadrao,
            fillOpacity: this.opacidadePadrao
        };
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            title: observable,
            color: observable,
            removerTooltip: observable,
            idPadrao: observable,
            openModalJustificativa: observable,
            atualizarPropsIcone: action,
            adicionarSxPadrao: action,
            handleOpenModalJustificativa: action,
            handleCloseModalJustificativa: action
        });

        runInAction(() => {
            this.idPadrao = this.props.id ? this.props.id : this.idPadrao;
        });
    }

    atualizarPropsIcone(propsIcone) {
        this.propsIcone = propsIcone;
    }

    /**
     * @desc Adiciona as propriedades padrão sem sobrescrever as existentes.
     */
    adicionarSxPadrao() {
        if (!Object.prototype.hasOwnProperty.call(this.propsIcone, 'sx')) {
            runInAction(() => {
                this.propsIcone.sx = IconeAdvogadoPedidoDestaque.sxPadrao;
            });
        } else {
            runInAction(() => {
                this.propsIcone.sx = { ...IconeAdvogadoPedidoDestaque.sxPadrao, ...this.propsIcone.sx };
            });
        }
    }

    handleOpenModalJustificativa = () => {
        this.openModalJustificativa = true;
    };

    handleCloseModalJustificativa = () => {
        this.openModalJustificativa = false;
    };

    getCorIcone() {
        if (this.props.deferimento?.tipoSituacao?.codigo === 'NA') {
            return grey[500];
        } else if (this.props.deferimento?.deferido === true) {
            return green[900];
        } else if (this.props.deferimento?.deferido === false) {
            return red[900];
        } else {
            return 'black';
        }
    }

    render() {
        if (this.removerTooltip) {
            return <BookmarkAddIcon sx={this.props.sx ? this.props.sx : this.props.style} />;
        } else {
            return (
                <>
                    <Tooltip title={<Typography>{this.titlePadrao + this.situacaoPedidoDestaque}</Typography>}>
                        {this.props.motivoDestaque ? (
                            <IconButton
                                sx={{ p: 0.5, ml: 0.5 }}
                                onClick={this.handleOpenModalJustificativa}
                                size="large"
                            >
                                <BookmarkAddIcon style={{ fill: this.getCorIcone() }} />
                            </IconButton>
                        ) : (
                            <BookmarkAddIcon
                                id={this.idPadrao}
                                sx={this.props.sx ? this.props.sx : this.props.style}
                                style={{ fill: this.getCorIcone() }}
                            />
                        )}
                    </Tooltip>{' '}
                    <Dialog
                        open={this.openModalJustificativa}
                        maxWidth="lg"
                    >
                        <DialogTitle>Justificativa do Pedido de destaque</DialogTitle>
                        <DialogContent>
                            <Table>
                                <TableRow>
                                    <TableCell sx={{ width: '200px' }}>
                                        <Typography sx={{ fontWeight: 'bold' }}>Situação do pedido:</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Chip
                                            label={this.props.deferimento?.tipoSituacao?.descricao}
                                            sx={{ backgroundColor: this.getCorIcone(), color: 'white' }}
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ width: '200px' }}>
                                        <Typography sx={{ fontWeight: 'bold' }}>Solicitação do advogado:</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Box
                                            sx={{ minWidth: '700px' }}
                                            dangerouslySetInnerHTML={{ __html: this.props.motivoDestaque }}
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ width: '200px' }}>
                                        <Typography sx={{ fontWeight: 'bold' }}>Resposta ao pedido:</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Box
                                            sx={{ minWidth: '700px' }}
                                            dangerouslySetInnerHTML={{ __html: this.props.motivoDeferimento }}
                                        />
                                    </TableCell>
                                </TableRow>
                            </Table>
                        </DialogContent>
                        <DialogActions sx={{ mt: 1.5, mb: 1, mr: 1 }}>
                            <Button
                                onClick={this.handleCloseModalJustificativa}
                                color="secondary"
                                variant="outlined"
                                endIcon={<Cancel />}
                            >
                                Fechar
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            );
        }
    }
}

IconeAdvogadoPedidoDestaque.corPadrao = 'black';

IconeAdvogadoPedidoDestaque.opacidadePadrao = '1';

IconeAdvogadoPedidoDestaque.propTypes = {
    removerEstiloPadrao: PropTypes.bool,
    removerTooltip: PropTypes.bool,
    title: PropTypes.node,
    sx: PropTypes.object,
    style: PropTypes.object,
    id: PropTypes.string
};

export default observer(IconeAdvogadoPedidoDestaque);
